jQuery(function($) {

  //Virtually Maps clicks from our custom Share Icons to addThis Share Buttons
  //NOTE: We are using some vanilla JS in here specifically for compatability with addThis's JS
  $( document ).ready(function() {
    $(".custom-share-button").click(function(ev) {
      //console.log($elem);
      var $button    = $(ev.currentTarget);
      var buttonType = $button.attr('button-type');
      var elemList   = [];
      var baseClass  = window.addThisBaseClass || 'at-svc-';

      elemList = document.getElementsByClassName(baseClass + buttonType);

      console.log('virtual click: ' + baseClass + buttonType);
      console.log(elemList);

      if (elemList[0]) {
        simulateClick(elemList[0]);
      }
    });

    function simulateClick (elem) {
    	// Create our event (with options)
    	var evt = new MouseEvent('click', {
    		bubbles: true,
    		cancelable: true,
    		view: window
    	});
    	// If cancelled, don't dispatch our event
    	var canceled = !elem.dispatchEvent(evt);
    }
  });
});

// var curday;
// var secTime;
// var ticker;
 
// function getSeconds() {
//     var nowDate = new Date();
//     //Sunday through Saturday, 0 to 6
//     var dy = 0;
//     //var dy = 1;
//     // 8:00 am in CST is 4:45 pm in UTC | EX: 20 out of 24 hours = 8pm | https://savvytime.com/converter/cst-to-utc
//     var countertime = new Date(Date.UTC(nowDate.getUTCFullYear(),nowDate.getUTCMonth(), nowDate.getUTCDate(), 14, 00, 0)); 
//     //var countertime = new Date(Date.UTC(nowDate.getUTCFullYear(),nowDate.getUTCMonth(), nowDate.getUTCDate(), 22, 12, 0)); 
//     console.group(countertime);
//     //current time
//     var curtime = nowDate.getTime(); 
//     //countdown time
//     var atime = countertime.getTime();
//     var diff = parseInt((atime - curtime)/1000);
    
//     if (diff > 0) { 
//         curday = dy - nowDate.getDay() 
//     } else { 
//         curday = dy - nowDate.getDay() -1 
//     } //after countdown time

//     if (curday < 0) { 
//         curday += 7; 
//     } //already after countdown time, switch to next week
    
//     if (diff <= 0) { 
//         diff += (86400 * 7) 
//     }
    
//     startTimer (diff);
// }
 
// function startTimer(secs) {
//     secTime = parseInt(secs);
//     ticker = setInterval(tick,1000);
// }
 
// function tick() {
//     var secs = secTime;
    
//     if (secs > 0) {
//         secTime--;
//     }
//     else {
//         clearInterval(ticker);
//         getSeconds(); // Start over
//         watchLive(); // Make watch live btn red and hide timer
//     }
    
//     var days = Math.floor(secs/86400);
//     secs %= 86400;
//     var hours= Math.floor(secs/3600);
//     secs %= 3600;
//     var mins = Math.floor(secs/60);
//     secs %= 60;

//     var dayWrap = document.querySelectorAll('#days');
//     var textWrap = document.querySelectorAll('#days-text');
//     var hrsWrap = document.querySelectorAll('#hours');
//     var minsWrap = document.querySelectorAll('#minutes');
//     var secsWrap = document.querySelectorAll('#seconds');

//     // Update the word "day" based on number of days away from Sunday
//     // Less than one day will hide the number of days and "day(s)" text 
//     if (curday >= 1 ) {

//         if (curday == 1) {
//             var text = "day";
//         }
//         else {
//             var text = "days";
//         }

//         for(var i = 0; i < dayWrap.length; i++){
//             dayWrap[i].innerHTML = curday;
//         }

//         for(var i = 0; i < textWrap.length; i++){
//             textWrap[i].innerHTML = text;
//         }

//     } else {  
        
//         for(var i = 0; i < dayWrap.length; i++){
//             dayWrap[i].setAttribute('style', 'display:none;');
//         }

//         for(var i = 0; i < textWrap.length; i++){
//             textWrap[i].setAttribute('style', 'display:none;');
//         }
//     }  
    
//     // We always show the hours, minutes, and seconds
//     for(var i = 0; i < hrsWrap.length; i++){
//         hrsWrap[i].innerHTML = ((hours < 10 ) ? "0" : "" ) + hours;
//     }

//     for(var i = 0; i < minsWrap.length; i++){
//         minsWrap[i].innerHTML = ( (mins < 10) ? "0" : "" ) + mins;
//     }

//     for(var i = 0; i < secsWrap.length; i++){
//         secsWrap[i].innerHTML = ( (secs < 10) ? "0" : "" ) + secs;
//     }
// }

// function watchLive() {

//     var watchBtn = document.querySelectorAll('#watch-live-btn');
//     var mobileCountholder = document.querySelectorAll('#mobile-countholder');
    
//     // Turn watch live btn red
//     for(var i = 0; i < watchBtn.length; i++){
//         watchBtn[i].className = "red";
//     }

//     // Show Mobile topbar watch live btn
//     for(var i = 0; i < mobileCountholder.length; i++){
//         mobileCountholder[i].setAttribute('style', 'display:block;');
//     }

//     // Wait 1hr to revert the above changes
//     // 1 minute is 60000 miliseconds for test purposes
//     //setInterval(revertCountdown, 60000); 
//     setInterval(revertCountdown, 3600000); 
// } 

// function revertCountdown() {

//     var watchBtn = document.querySelectorAll('#watch-live-btn');
//     var countHolder = document.querySelectorAll('#countholder');
//     var mobileCountholder = document.querySelectorAll('#mobile-countholder');

//     // Revert back to gray watch live btn
//     for(var i = 0; i < watchBtn.length; i++){
//         watchBtn[i].className = "watch-link";
//     }

//     // Show countdown again
//     for(var i = 0; i < countHolder.length; i++){
//         countHolder[i].setAttribute('style', 'display:flex;');
//     }

//     // Hide mobile topbar watch live btn
//     for(var i = 0; i < mobileCountholder.length; i++){
//         mobileCountholder[i].setAttribute('style', 'display:none;');
//     }

//     tick();
// }

jQuery(function($) {
  $(document).ready(function() {
    // Check for counter presence before running code
    if ($('.service_counter').length) {
      newCountdown();
    }

    function newCountdown() {
      var countDownDate = new Date(window.nextEvent.special_event_time).getTime();

      // Update the count on init
      tick();

      // Update the count down every 1 second
      var tickInterval = setInterval(tick, 1000);

      function tick() {
        // Get todays date and time
        var nowTime  = new Date().getTime();
        var distance = countDownDate - nowTime;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // If the count down is finished, reload page
        if (distance < 0) {
          clearInterval(tickInterval);
          location.reload();
        }
        else {
          $('.service_counter .days').html(function() {
            return ( (days < 10 ) ? ("0" + days) : days );
          });
          $('.service_counter .hours').html(function() {
            return ( (hours < 10 ) ? ("0" + hours) : hours );
          });
          $('.service_counter .minutes').html(function() {
            return ( (minutes < 10) ? ("0" + minutes) : minutes );
          });
          $('.service_counter .seconds').html(function() {
            return ( (seconds < 10) ? ("0" + seconds) : seconds );
          });
        }
      }
    }
  });
});

jQuery(function($) {

    initMobileMenu();
    youtubeModalPlay();
    vimeoVideoPlay();
    youtubeVideoPlay();
    eventSliderHover();
    mainNavBackgroundFallback();
    initFancyList();
    initFormFancyList();
    messagesLoader();

    function messagesLoader() {
      window.messagesPage = 2;

      $('.load-more-messages').click(function() {
        $.ajax({
           type:     'GET',
           url:      '/wp/wp-admin/admin-ajax.php?action=load_messages&page=' + window.messagesPage,
           dataType: "json",
           headers: {
             'Content-Type': 'application/json'
           },
           success: function(data){
             var $messages = $('.recent-series .message-cards');
             var $newMessages;

             window.messagePage++;

             if (data && data.body) {
               $newMessages = data.body;

               $messages.append($newMessages);
             }

             if (data && !data.show_more) {
               $('.load-more-messages button').remove();
               $('.load-more-messages').append('<h4>No more messages available.</h4>');
             }
           },
           error: function (e) {
             console.log('Error while fetching more messages', e);
           }
        });
      });
    }

    function initMobileMenu() {
        $('.mobile-nav-menu .menu-item-has-children').append('<span class="submenu-toggle"></span>');
        $('.mobile-nav-hamburger').on('click', function () {
            $('body, html').toggleClass('body-is-mobile');
            $('.mobile-nav-background').toggleClass('is-mobile');
            $('.mobile-nav-hamburger').toggleClass('mobile-burger');
            $('.burger').toggleClass('burger-x');
            $('.mobile-nav-menu-links').toggleClass('mobile-links-visible');
            $('.topbar-color-logo').toggleClass('hide');
            $('.topbar-white-logo').toggleClass('show');
            $('.mobile-info-wrapper').toggleClass('hide');
        });

        $('.mobile-nav-menu .menu-item-has-children > .submenu-toggle').on('click', function (e) {
            e.preventDefault();
            $('.mobile-nav-menu .menu-item-has-children').not($(this).parent()).removeClass('mobile-show-submenu');
            $(this).parent().toggleClass('mobile-show-submenu');
        });
    }

    function youtubeModalPlay() {
      $('.media-modal-link').click(function (ev) {
        var $link     = $(ev.currentTarget);
        var mediaType = $link.attr('media-type');
        var content   = $('.hidden-modal-content[media-type="' + mediaType + '"] > *');

        console.log('slug', '.hidden-modal-content[media-type="' + mediaType + '"]');

        setTimeout(function () {
          $.magnificPopup.open({
            removalDelay: 0,
            closeBtnInside: true,
            showCloseBtn: true,
            overflowY: 'scroll',
            items: {
              src: content
            },
            type: 'inline'
          });
        }, 100);
      });
    }

    function vimeoVideoPlay() {

        // List of all feature slider videos
        var $singleVideoModal = $('.video-modal-content .video-modal-wrap');

        // Setup our video handler for each item in our video list
        $singleVideoModal.each(setupVideo);

        // Sets up a single video slide
        function setupVideo(i, elem) {
            var $video = $(elem);
            var $iframe = $video.find('iframe');
            var player  = new Vimeo.Player($iframe[0]);
            var opened  = false;

            player.on('play', openVideo);

            // If our video slide has not already been opened, hide our overlay and unhide our vimeo iframe
            function openVideo() {
                if (!opened) {
                    $iframe.css('opacity', 1);
                    setTimeout(function () {
                        $( ".video-modal-content .video-modal-wrap .video-overlay" ).fadeOut(5000);
                    }, 1);

                    opened = true;
                }
            }
        }
    }

    function youtubeVideoPlay() {

        // Setup our video handler for each item in our video list
        var $playicon =  $('.yt-video-modal-content .yt-video-modal-wrap .video-overlay .play-icon');
            
        $playicon.on( 'click', function (ev) {
            ev.preventDefault();
            var $video = $(this).parentsUntil(".fbyf-single-video-wrapper");
            var $iframe = $video.find('iframe');
            $iframe[0].src += "?rel=0&autoplay=1";

            setTimeout(function () {
                $video.find( ".video-overlay" ).fadeOut(1000);
            }, 1);
        });
    
    }

    function eventSliderHover() {
        //hover for upcoming events slider - ew
        $(".upcoming-events-slider .slick-track .slide-wrapper .inner-wrapper").hover(
            function () {
                $(this).find('.overlay').css("transform", "translateY(0%)");
                $(this).find('.fbyf-btn-wrapper').css("transform", "translateY(0%)");
            },
            function () {
                $(this).find('.overlay').css("transform", "translateY(150%)");
                $(this).find('.fbyf-btn-wrapper').css("transform", "translateY(280%)");
            }
        );
    }

    function mainNavBackgroundFallback() {
        // Since the main navigation is transparent for most pages which use the main masthead module
        // displaying background video or images, this handles pages that do not have the masthead
        // module, and message cpt

        $mastHead = $('.fbyf-primary-masthead');
        $messageHero = $('.message-hero-wrapper');
        $mainMenu = $('main-menu--container');
        $body = $('body');
        console.log($messageHero);
        if ($mastHead.length == 0 && $messageHero.length == 0 ) {
            // No masthead detected
            // Add class to the body element
            $body.addClass('no-masthead-module');
        }
    }

    function initFancyList() {
        var $list = $('.content-wrapper .fl-rich-text > ul > li');

        $list.click(function () {
            var $elm    = $(this);
            var $subnav = $elm.find('> ul');

            if ($subnav[0]) {
                $subnav.slideToggle();
                $elm.toggleClass('active');
            }
        });
    }

    function initFormFancyList() {
        var $arrow = $('.forms-dropdowns > .form-item > .dropdown-arrow');
        var $listText = $('.forms-dropdowns > .form-item > p');
        //var $list = $('.forms-dropdowns > .form-item');

        $arrow.click(function () {
            var $elm    = $(this).parent();
            var $subnav = $elm.find(' > ul');

            if ($subnav[0]) {
                $subnav.slideToggle();
                $elm.toggleClass('active');
            }
        });

        $listText.click(function () {
            var $elm    = $(this).parent();
            var $subnav = $elm.find(' > ul');

            if ($subnav[0]) {
                $subnav.slideToggle();
                $elm.toggleClass('active');
            }
        });
    }
});
